import edeptLogo from '@/assets/edept2.png';
import { Mail, Phone } from 'lucide-react';


export default function Footer() {
  return (
    <footer className="bg-slate-950 py-12 text-white/70">
      <div className="container-content grid gap-8 px-6 sm:px-10 lg:grid-cols-3 lg:px-16">
        <div>
          <img
            src={edeptLogo}
            alt="edept"
            className="h-10 w-auto"
            loading="lazy"
          />
         <p className="mt-4 max-w-xs text-base leading-8">
            edept designs and delivers global hybrid Master’s pathways in partnership with leading universities.
          </p>
        </div>

        <div>
          <p className="text-sm font-semibold uppercase tracking-widest text-white/50">Program</p>
          <ul className="mt-3 space-y-2 text-sm">
            <li>
              <a href="#program" className="hover:text-white">
                Program overview
              </a>
            </li>
            <li>
              <a href="#outcomes" className="hover:text-white">
                Graduate outcomes
              </a>
            </li>
            <li>
              <a href="#faqs" className="hover:text-white">
                FAQs
              </a>
            </li>
          </ul>
        </div>

        <div>
          <p className="text-sm font-semibold uppercase tracking-widest text-white/50">Contact</p>
          {/* TODO: replace with verified admissions contact details from the brochure. */}
          <ul className="mt-3 space-y-2 text-sm flex flex-col ">
            <li className='flex items-center'> <Phone className=" mr-2 h-4" />Chanchal: 9359282433</li>
            
           <a href="mailto:admissions@edept.co"> <li className='flex items-center'> <Mail className=" mr-2 h-4" />admissions@edept.co</li></a>
          </ul>
        </div>
      </div>

      <div className="container-content mt-10 border-t border-white/10 px-6 pt-6 text-xs text-white/40 sm:px-10 lg:px-16">
        <p>© {new Date().getFullYear()} edept. All rights reserved.</p>
      </div>
    </footer>
  );
}
